import React from 'react';
import { Result } from 'antd';
import useUser from "hooks/useUser";

const LoggedInGuard = (props) => {

  const { loggedOut } = useUser();

  const { children } = props;

  const NotFound = () => {
    return (
      <Result 
        title="Unauthorised Access"
        subTitle="You must be logged in to view this page"
        status="warning" 
        />
    );
  }

  return (
    <>
      {loggedOut ? (
        <NotFound />
      ) : (
        <>{children}</>
      )}
    </>
  )

}

export default LoggedInGuard;
